import React from 'react';
import { CTAWithIntro } from '../Poll.model';
import './PollCTA.scss';
import { Cta } from '../../../../../components/blackrock/advisor-center/cta/Cta';

export const PollCTA: React.FC<
	CTAWithIntro['callToAction'] & Pick<CTAWithIntro, 'description'>
> = ({ label, url, description, target, ariaLabel, dataLinkEvent }) => (
	<div className="poll-cta">
		{description && (
			<p className={'poll-cta-intro blk-ac-body-m'}>{description}</p>
		)}
		{label && (
			<Cta
				url={url}
				target={target}
				ariaLabel={ariaLabel}
				dataLinkEvent={dataLinkEvent}
				label={label}
			/>
		)}
	</div>
);
